import Stepper from "../components/Support/Stepper";

const SupportPage = () => {
    return(
        <Stepper />
    )
}

export default SupportPage;